import { createSvgIcon } from '@mui/material';

const XlIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19.999"
    height="19.062"
    viewBox="0 0 19.999 19.062"
  >
    <g id="Group_4325" data-name="Group 4325" transform="translate(-968.751 -804.665)">
      <rect
        id="Rectangle_2606"
        data-name="Rectangle 2606"
        width="9.25"
        height="8.772"
        rx="1"
        transform="translate(969.501 814.204)"
        fill="none"
        stroke="#85C440"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <rect
        id="Rectangle_3207"
        data-name="Rectangle 3207"
        width="9.25"
        height="8.772"
        rx="1"
        transform="translate(978.75 814.204)"
        fill="none"
        stroke="#85C440"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <rect
        id="Rectangle_3208"
        data-name="Rectangle 3208"
        width="9.25"
        height="8.772"
        rx="1"
        transform="translate(973.75 805.423)"
        fill="none"
        stroke="#85C440"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <path
        id="Path_2821"
        data-name="Path 2821"
        d="M1188.078,512.271l-1.5-1.236-1.417,1.236v-5.158h2.914Z"
        transform="translate(-212.234 307.083)"
        fill="none"
        stroke="#85C440"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <path
        id="Path_3433"
        data-name="Path 3433"
        d="M1188.078,512.271l-1.5-1.236-1.417,1.236v-5.158h2.914Z"
        transform="translate(-202.984 307.083)"
        fill="none"
        stroke="#85C440"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <path
        id="Path_3434"
        data-name="Path 3434"
        d="M1188.078,512.271l-1.5-1.236-1.417,1.236v-5.158h2.914Z"
        transform="translate(-207.984 298.302)"
        fill="none"
        stroke="#85C440"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
    </g>
  </svg>,
  'XlIcon',
);

export default XlIcon;
